export { ThemeProvider, useTheme } from 'next-themes';
export type Theme = 'light' | 'dark' | 'system';
